import { render, staticRenderFns } from "./EleccionesPrimarias.vue?vue&type=template&id=1437820d&scoped=true&"
import script from "./EleccionesPrimarias.vue?vue&type=script&lang=js&"
export * from "./EleccionesPrimarias.vue?vue&type=script&lang=js&"
import style0 from "./EleccionesPrimarias.vue?vue&type=style&index=0&id=1437820d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437820d",
  null
  
)

export default component.exports